/* eslint-disable no-use-before-define */
import React from 'react'
import { hideModal, arrayFrom, } from '../../twd/twd'
import Redemptions from './redemptions'
import MaterialEventFilings from './material-event-filings'
import DisclosureFilings from './disclosure-filings'
import CreditRatingActions from './credit-rating-actions'
import DefaultEvents from './default-events'
import { hasCreditRatings } from '../use-bond-detail'

export default ({issue, events=[], tab:tab_='default-events'} = {}) => {

    const [tab, setTab] = React.useState(tab_ || 'default-events')
    let invType = issue.type
    let isMuni = invType === 'M'
    let isAgcy = invType === 'A'
    let isCorp = !isMuni && !isAgcy

    let hasRtg = hasCreditRatings(issue)
    let title = 'Events' + (hasRtg ? ' and Ratings' : '')

    return <React.Fragment>
    <div className="modal-dialog modal-lg">
    <div className="modal-content">

    <div className="modal-header">
        <button
            data-name="bond-detail-underwriter-close"
            className="close"
            aria-label="close"
            type="button"
            onClick={hideModal}>
        <i className="material-icons" aria-hidden="true">close</i>
        </button>
        <h3 className="large-header text-center vertical-offset-sm">{title}</h3>
    </div>

    <div className="container" style={{background:"#ffffff" }}>
    <div className="row">
        <div className="col-md-9">
            <h3><b>{issue.issueDisplay}</b></h3>
        </div>
        <div className="col-md-3 text-right text-bold">
            {issue.cusip}
        </div>
    </div>
    </div>

    <div className="row"><div className="col-xs-12 vertical-offset-sm">
        <div
            data-name="faq-nav-tabs"
            className="nav-tabs nav-tabs-border">
        <ul>
            { isCorp && <li className={tab==='default-events' ? 'active' : ''}>
            <button
                data-name="events-ratings-default-events"
                className="subhead"
                onClick={() => setTab('default-events')}>Default Events</button>
            </li> }

            { isMuni && <li className={tab==='material-event-filings' ? 'active' : ''}>
            <button
                data-name="events-ratings-material-event-filings"
                className="subhead"
                onClick={() => setTab('material-event-filings')}>Material Event Filings</button>
            </li> }

            { isMuni && <li className={tab==='disclosure-filings' ? 'active' : ''}>
            <button
                data-name="events-ratings-disclosure-filings"
                className="subhead"
                onClick={() => setTab('disclosure-filings')}>Disclosure Filings</button>
            </li> }

            <li className={tab==='redemptions' ? 'active' : ''}>
            <button
                data-name="events-ratings-redemptions"
                className="subhead"
                onClick={() => setTab('redemptions')}>Redemptions</button>
            </li>

            { hasRtg && <li className={tab==='credit-ratings-actions' ? 'active' : ''}>
            <button
                data-name="events-ratings-credit-ratings-actions"
                className="subhead"
                onClick={() => setTab('credit-ratings-actions')}>Credit Rating Actions</button>
            </li> }
        </ul>
        </div>
    </div></div>

    <div className="row vertical-offset-sm">
    <div className="col-xs-12">
        {tab==='default-events' && <DefaultEvents
            rows={arrayFrom((events.filter((e) => e.eventName==='taxabledefaultevents')[0] || {}).eventList)}
        />}
        {tab==='material-event-filings' && <MaterialEventFilings
            rows={arrayFrom((events.filter((e) => e.eventName==='eventfilings')[0] || {}).eventList)}
        />}
        {tab==='disclosure-filings' && <DisclosureFilings
            rows={arrayFrom((events.filter((e) => e.eventName==='disclosurefiling')[0] || {}).eventList)}
        />}
        {tab==='redemptions' && <Redemptions
            rows={arrayFrom((events.filter((e) => e.eventName==='redemptions')[0] || {}).eventList)}
        />}
        {tab==='credit-ratings-actions' && <CreditRatingActions
            rows={arrayFrom((events.filter((e) => e.eventName==='creditrating')[0] || {}).creditRatingList)}
        />}
    </div>
    <div className="col-md-2 col-xs-1"></div>
    </div>

    </div>
    </div>
    </React.Fragment>
}
